var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{attrs:{"active-color":"#409EFF","inactive-color":"#91939A"},on:{"change":_vm.changeValue},model:{value:(_vm.switchValue),callback:function ($$v) {_vm.switchValue=$$v},expression:"switchValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }